import React from "react"



const MenuCloser = ({ siteTitle }) => (
  <div id="menuCloser" className="pos-f lt0 lr0 right h100 soft col-sm-w65 col-xs-w20 z50" style={{backgroundColor:"rgba(255,255,255,.1)"}}></div>
)
export default MenuCloser
